import { useQuery } from "@apollo/client/react";

import { DdiHomeFilterInputFilterType } from '../components';
import { DDI_HOME_REPORT_CHART } from '../graphql';

interface UseDdiHomeReportChartProps {
  filters: DdiHomeFilterInputFilterType;
  skip: boolean;
}

export const useDdiHomeReportChart = ({ filters, skip }: UseDdiHomeReportChartProps) => {
  const { metric: _metric, ...filterInput } = filters;
  const { data, loading, error, refetch } = useQuery(DDI_HOME_REPORT_CHART, {
    variables: {
      input: filterInput,
    },
    skip,
  });

  return {
    reportChart: data?.ddiHomeReportChart,
    loading,
    error,
    refetch,
  };
};
